module.exports = __webpack_public_path__ + "static/chinet-logo-2622c9a77a07283502544e58829c2274.png";